import React from 'react';
import { Globe, FlaskConical, Clock, Blocks } from 'lucide-react';

const LABELS = ['A', 'B', 'C', 'D'];

const CATEGORY_CONFIG = {
  web3: { label: 'Web3', icon: Blocks, color: 'text-purple-300 bg-purple-500/15 border-purple-500/25' },
  geography: { label: 'Geography', icon: Globe, color: 'text-cyan-300 bg-cyan-500/15 border-cyan-500/25' },
  science: { label: 'Science', icon: FlaskConical, color: 'text-green-300 bg-green-500/15 border-green-500/25' },
  history: { label: 'History', icon: Clock, color: 'text-amber-300 bg-amber-500/15 border-amber-500/25' },
};

export const GerryQuizCard = ({ question, questionNum, totalQuestions, answered, onAnswer }) => {
  const cat = CATEGORY_CONFIG[question.category] || CATEGORY_CONFIG.web3;
  const CatIcon = cat.icon;

  return (
    <div className="mx-3 mb-2 p-3 rounded-xl bg-purple-900/30 border border-purple-500/30" data-testid="gerry-quiz-card">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <p className="text-[10px] text-purple-300 font-bold uppercase tracking-wider">
            Question {questionNum} of {totalQuestions}
          </p>
          <span className={`inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-[9px] font-bold border ${cat.color}`} data-testid="quiz-category-badge">
            <CatIcon className="w-2.5 h-2.5" />
            {cat.label}
          </span>
        </div>
        <div className="flex gap-1">
          {Array.from({ length: totalQuestions }, (_, i) => (
            <div
              key={i}
              className={`w-2 h-2 rounded-full ${
                i < questionNum - 1 ? 'bg-purple-400' : i === questionNum - 1 ? 'bg-orange-400 animate-pulse' : 'bg-gray-600'
              }`}
            />
          ))}
        </div>
      </div>
      <p className="text-sm text-white font-bold mb-3">{question.question}</p>
      <div className="space-y-1.5">
        {question.options.map((opt, i) => {
          let style = 'bg-gray-800/80 border-gray-700 text-gray-300 hover:border-purple-500/50 hover:text-white cursor-pointer';
          if (answered !== null) {
            if (i === question.correct) {
              style = 'bg-green-500/20 border-green-500/50 text-green-300';
            } else if (i === answered && i !== question.correct) {
              style = 'bg-red-500/20 border-red-500/50 text-red-300 line-through';
            } else {
              style = 'bg-gray-800/40 border-gray-700/30 text-gray-500';
            }
          }
          return (
            <button
              key={i}
              onClick={() => answered === null && onAnswer(i)}
              disabled={answered !== null}
              className={`w-full text-left px-3 py-2 rounded-lg border text-xs font-medium transition-all ${style}`}
              data-testid={`quiz-option-${i}`}
            >
              <span className="font-bold mr-1.5">{LABELS[i]}.</span> {opt}
            </button>
          );
        })}
      </div>
      {answered !== null && (
        <div className={`mt-2.5 px-2.5 py-1.5 rounded-lg text-xs font-bold ${
          answered === question.correct
            ? 'bg-green-500/10 text-green-400 border border-green-500/20'
            : 'bg-red-500/10 text-red-400 border border-red-500/20'
        }`} data-testid="quiz-feedback">
          {answered === question.correct
            ? '+5 XP! Great job!'
            : `Not quite! The answer was ${LABELS[question.correct]}.`}
        </div>
      )}
    </div>
  );
};
